module.exports = __webpack_public_path__ + "img/pro-xtslider3.cd10f74a.png";